import { TabContainer, ThankyouHeader, ThankyouMessage } from "./Social.styled";
import thanks from "../../assets/thanks.svg";
import { ButtonSecondary } from "../../screens/login.screen/login.styled";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { Link} from "react-router-dom";
import { observer } from "mobx-react";
import General from "../../stores/GeneralStore";
import HappyMeterStore from "../../stores/HappyMeter";
import { ButtonContainer } from "../../screens/login.screen/login.styled";
import { SpinnerRaw } from "../spinner.component";

const Thankyou = ({ msg, title, referenceId, serviceID, orderIdRegister = false, downloadLoader, downloadBillPDF }: any) => {
  const navigate = useNavigate();

  // () => navigate('/dashboard')
  useEffect(() => {
    HappyMeterStore.setUpTranctionId(referenceId);
    HappyMeterStore.setUPserviceID(serviceID);
    HappyMeterStore.openHappinessMeter();
    localStorage.removeItem('value');
  }, []);

  const ColorAss = General?.ColorAss;
  const contrast = General?.contrast;

  const backButtonHandler = () => {
    HappyMeterStore.openHappinessMeter();
    localStorage.removeItem("value");
    localStorage.removeItem("movein");
  };

  return (
    <div style={{ display: 'flex', width: "100%", justifyContent: "center" }}>
      <div
        style={{
          width: General?.isLargeScreen ? "100%" : "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "flex-start",
          alignSelf: "flex-start",

          background: contrast?.contrastBackground ? contrast?.contrastBackground : 'white'
        }}
      >
        <ThankyouHeader style={{ background: contrast?.contrastBackground ? contrast?.contrastBackground : '#e0eedc' }}>
          <img src={thanks} alt="" />
          <h1 style={{
            margin: "0", marginBottom: "13px", fontFamily: 'Segoe UI',
            fontStyle: "normal",
            fontWeight: "400",
            fontSize: `${2.125 * General.accessibility.fontSize}rem`,
            lineHeight: "130%",
            color: General.contrast.contrastBackground
            ? General.contrast.contrastColor
            : General?.ColorAss,
          }}>

            {General?.codeLabels["cm_thankyou"]?.label !== undefined ? General?.codeLabels["cm_thankyou"]?.label : "Thank You"}

          </h1>
        </ThankyouHeader>
        <ThankyouMessage>
          <p style={{
            padding: "0",
            margin: "0",
            marginTop: "20px",
            marginBottom: "20px",
            fontSize: `${General.accessibility.fontSize}rem`,
            fontWeight: "700",
            textAlign: "center",
            color: General.contrast.contrastBackground
            ? General.contrast.contrastColor
            : General?.ColorAss,
          }}
            dangerouslySetInnerHTML={{ __html: title ? title : serviceID == 5 ? "Service Activation ": General?.codeLabels["cm_your_social"]?.label ? General?.codeLabels["cm_your_social"]?.label : 'Your Social Case Application has been submitted' }}
          >
            {/* {title ? title : General?.codeLabels["cm_your_social"]?.label ? General?.codeLabels["cm_your_social"]?.label : 'Your Social Case Application has been submitted'} */}
          </p>
          {(serviceID != 1 && !orderIdRegister) && <>
            <p
              style={{ fontSize: `${General.accessibility.fontSize}rem`, margin: "0", fontWeight: "700", lineHeight: "120%", color: General.contrast.contrastBackground
              ? General.contrast.contrastColor
              : General?.ColorAss, }}
              dangerouslySetInnerHTML={{ __html: msg ? msg : General?.codeLabels['cm_referenceid']?.label }}>
              {/* {msg ? msg : General?.codeLabels['cm_referenceid']?.label} */}
            </p>

            <h4 style={{ margin: "0", fontSize: `${1.875 * General.accessibility.fontSize}rem`, fontWeight: "700", lineHeight: "150%", marginBottom: "40px", color: General.contrast.contrastBackground
            ? General.contrast.contrastColor
            : General?.ColorAss, }}>{serviceID !== 1 && referenceId ? referenceId : ''}</h4>
          </>}
          <ButtonContainer
            style={{
              display: "flex",
              flexDirection: General?.isLargeScreen ? "row" : "column",
              justifyContent: "space-around",
            }}
          >
            <ButtonSecondary
              
              onClick={() => navigate('/dashboard')}
              style={{ 
                height: "50px", 
                width: "252px", 
                fontFamily: "Segoe UI", 
                fontWeight: "700", 
                fontSize: `${General.accessibility.fontSize}rem`, 
                lineHeight: "130%", 
                color: General.contrast.contrastColor
                ? General.contrast.contrastBackground
                : '#fff',
  background: General.contrast.contrastBackground
            ? General.contrast.contrastColor
            : General?.ColorAss,
                whiteSpace: "nowrap", border: 'none' }}>
              {General?.codeLabels["cm_back_dashboard"]?.label ? General?.codeLabels["cm_back_dashboard"]?.label : 'BACK TO DASHBOARD'}
            </ButtonSecondary>
            {serviceID == 3 && <ButtonSecondary
              onClick={downloadBillPDF}
              style={{
                background: contrast?.contrastColor ? contrast?.contrastBackground : General?.ColorAss,
                color: contrast?.contrastBackground ? contrast?.contrastColor : '#fff',
                width: General?.isLargeScreen ? "30%" : "70%",
                padding: "10px 10px",
                marginBottom: "1rem",
                fontSize: `${General.accessibility.fontSize}rem`,
              }}
            >
              {downloadLoader ? (
                <SpinnerRaw width={30} height={30} />
              ) : General?.codeLabels["cm_downloadfilepdctable"]
                ?.label ? (
                General?.codeLabels["cm_downloadfilepdctable"]?.label
              ) : (
                "Download File"
              )}
            </ButtonSecondary>}
          </ButtonContainer>
          {serviceID == 3 && <p
              style={{
                fontSize: `${General.accessibility.fontSize}rem`,
                margin: "0",
                fontWeight: "700",
                lineHeight: "120%",
                color: contrast?.contrastColor ? contrast?.contrastColor : ColorAss,
                marginBottom: "1rem",
              }}
            >
              {General?.codeLabels["cm_rfnd_tnsfr_msg"]?.label} <Link style={{ color: contrast?.contrastColor ? contrast?.contrastColor : "rgb(16, 30, 142)", }} to={'/refund'}>{General?.codeLabels['cm_clickhere']?.label}</Link>
            </p>}
        </ThankyouMessage>
      </div>
    </div>
  );
};

export default observer(Thankyou);
